import axios from 'axios'
import constants from '../constants'

export default function init() {
  console.log('operationalData init')
}

export async function getBillingCycleUsage(app) {
  let URL = `${constants.customerDomain}apps/${app.id}/billing/`

  if (app.isAnnual && app.monthlyTermStart && app.monthlyTermEnd) {
    // If the app is annual and has monthly term start and end, we use those for billing cycle usage
    URL = `${URL}${app.monthlyTermStart * 1000}/${app.monthlyTermEnd * 1000}`
  } else {
    URL = `${URL}${app.currentTermStart * 1000}/${app.currentTermEnd * 1000}`
  }

  const ccBearerToken = localStorage.getItem('ccBearerToken')

  return axios
    .post(
      `${URL}`,
      { appids: [app.id] },
      {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      let err = {
        err_code: 'ERR',
        err_message:
          'We encountered an error. Please refresh your page and try again. Contact us if error persists.',
      }
      if (error.code !== undefined && error.code === 'ECONNABORTED') {
        err = {
          err_code: 'ECONNABORTED',
          err_message:
            'A request timeout occured. Please refresh your page and try again. Contact us if error persists.',
        }
      }

      return err
    })
}

export async function get(app, mauCall, peakCcuCall, voiceVideoCall, mcuCall, dcuCall) {
  const URL = `${constants.customerDomain}apps/${app.id}/metrics/`
  const one = `${URL}${mauCall.type}/${mauCall.startRange}/${mauCall.endRange}`
  const two = `${URL}${peakCcuCall.type}/${peakCcuCall.startRange}/${peakCcuCall.endRange}`
  const three = `${URL}voice/${voiceVideoCall.startRange}/${voiceVideoCall.endRange}`
  const four = `${URL}video/${voiceVideoCall.startRange}/${voiceVideoCall.endRange}`
  const five = `${URL}recording/${voiceVideoCall.startRange}/${voiceVideoCall.endRange}`
  const six = `${URL}${mcuCall.type}/${mcuCall.startRange}/${mcuCall.endRange}`
  const seven = `${URL}${dcuCall.type}/${dcuCall.startRange}/${dcuCall.endRange}`

  const ccBearerToken = localStorage.getItem('ccBearerToken')

  const requestOne = axios.get(`${one}`, {
    headers: { Authorization: `Bearer ${ccBearerToken}` },
    timeout: constants.timeout_in_ms.metrics,
  })

  const requestTwo = axios.get(`${two}`, {
    headers: { Authorization: `Bearer ${ccBearerToken}` },
    timeout: constants.timeout_in_ms.metrics,
  })

  const requestThree = axios.get(`${three}`, {
    headers: { Authorization: `Bearer ${ccBearerToken}` },
    timeout: constants.timeout_in_ms.metrics,
  })

  const requestFour = axios.get(`${four}`, {
    headers: { Authorization: `Bearer ${ccBearerToken}` },
    timeout: constants.timeout_in_ms.metrics,
  })

  const requestFive = axios.get(`${five}`, {
    headers: { Authorization: `Bearer ${ccBearerToken}` },
    timeout: constants.timeout_in_ms.metrics,
  })

  const requestSix = axios.get(`${six}`, {
    headers: { Authorization: `Bearer ${ccBearerToken}` },
    timeout: constants.timeout_in_ms.metrics,
  })

  const requestSeven = axios.get(`${seven}`, {
    headers: { Authorization: `Bearer ${ccBearerToken}` },
    timeout: constants.timeout_in_ms.metrics,
  })

  const structuredResponse = {
    mau: [],
    peakCcu: [],
    voice: [],
    video: [],
    recording: [],
    mcu: [],
    dcu: [],
    metricSuccess: true,
  }

  return axios
    .all(
      [requestOne, requestTwo, requestThree, requestFour, requestFive, requestSix, requestSeven],
      {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
        timeout: constants.timeout_in_ms.metrics,
      },
    )
    .then(
      axios.spread((...responses) => {
        structuredResponse.mau = responses[0].data
        structuredResponse.peakCcu = responses[1].data
        structuredResponse.voice = responses[2].data
        structuredResponse.video = responses[3].data
        structuredResponse.recording = responses[4].data
        structuredResponse.mcu = responses[5].data
        structuredResponse.dcu = responses[6].data
        structuredResponse.metricSuccess = true
        return structuredResponse
      }),
    )
    .catch(error => {
      let err = {
        err_code: 'ERR',
        err_message:
          'We encountered an error. Please refresh your page and try again. Contact us if error persists.',
      }
      if (error.code !== undefined && error.code === 'ECONNABORTED') {
        err = {
          err_code: 'ECONNABORTED',
          err_message:
            'A request timeout occured. Please refresh your page and try again. Contact us if error persists.',
        }
      }

      return err
    })
}
